var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "h2",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.createUserPending,
              expression: "createUserPending"
            }
          ],
          staticClass: "u-padding-bottom-20"
        },
        [_vm._v("Updating, please wait ...")]
      ),
      _vm._v(" "),
      _c("pulse-loader", {
        attrs: {
          loading: _vm.createUserPending,
          color: "#0F347B",
          size: "50px"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "createNewComp" },
        [
          _c(
            "b-form",
            { staticClass: "add-user-form" },
            [
              _c(
                "div",
                { staticClass: "header" },
                [
                  _c("h4", { staticClass: "card-title mb-0" }, [
                    _vm._v("Create New User")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-link",
                    { staticClass: "close", attrs: { to: "/admin/users/" } },
                    [_c("h4", [_vm._v("X")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "noBoxShadow" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "adduserlabel",
                                label: "State",
                                "label-for": "user-state"
                              }
                            },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  "data-vv-name": "stateName",
                                  "data-vv-as": "stateName",
                                  size: "lg",
                                  options: _vm.stateAndAbbrev,
                                  id: "stateName"
                                },
                                model: {
                                  value: _vm.stateName,
                                  callback: function($$v) {
                                    _vm.stateName = $$v
                                  },
                                  expression: "stateName"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.inputValidationErrors.has(
                                        "stateName"
                                      ),
                                      expression:
                                        "inputValidationErrors.has('stateName')"
                                    }
                                  ],
                                  staticClass: "text-info"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inputValidationErrors.first(
                                        "stateName"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "adduserlabel",
                                label: "Primary Organization",
                                "label-for": "primaryOrganization",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  size: "lg",
                                  "data-vv-name": "primaryOrganization",
                                  "data-vv-as": "Primary Organization",
                                  options: _vm.primaryOrganizations,
                                  id: "primaryOrganization"
                                },
                                model: {
                                  value: _vm.primaryOrganization,
                                  callback: function($$v) {
                                    _vm.primaryOrganization = $$v
                                  },
                                  expression: "primaryOrganization"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.inputValidationErrors.has(
                                        "primaryOrganization"
                                      ),
                                      expression:
                                        "inputValidationErrors.has('primaryOrganization')"
                                    }
                                  ],
                                  staticClass: "text-info"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inputValidationErrors.first(
                                        "primaryOrganization"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.newUsers, function(user, id) {
                            return _c("NewUserForm", {
                              key: id,
                              attrs: {
                                id: id,
                                formUser: user,
                                isSubmitLoading: _vm.isSubmitLoading
                              },
                              on: {
                                submit: function($event) {
                                  return _vm.setUser($event, id)
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "form-header",
                                    fn: function() {
                                      return [
                                        _vm._v(
                                          "\n                User " +
                                            _vm._s(id + 1) +
                                            "\n              "
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "add-user-form__button-group marginT20"
                            },
                            [
                              _vm.newUsers.length > 1
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "secondary" },
                                      on: { click: _vm.cancelUser }
                                    },
                                    [_vm._v("Cancel")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "primary",
                                    disabled: _vm.newUsers.length > 20
                                  },
                                  on: { click: _vm.addNewUser }
                                },
                                [_vm._v("Add Another User")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flexRowEnd marginT40" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "marginR-32",
                                  attrs: {
                                    variant: "primary",
                                    disabled:
                                      _vm.createUserPending ||
                                      _vm.emailSentInProcess
                                  },
                                  on: { click: _vm.submit }
                                },
                                [
                                  _vm._v(
                                    "\n                Submit\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "primary",
                                    disabled:
                                      _vm.createUserPending ||
                                      _vm.emailSentInProcess
                                  },
                                  on: { click: _vm.submitAndSendWelcomeEmails }
                                },
                                [
                                  _vm._v(
                                    "\n                Submit and Send Welcome Email(s)\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-alert",
                            {
                              attrs: {
                                fade: "",
                                show: _vm.createUserFailure,
                                variant: "danger"
                              }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.apiResponseMessage(
                                      _vm.createUserFailure,
                                      true
                                    )
                                  )
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-alert",
                            {
                              attrs: {
                                fade: "",
                                show:
                                  _vm.emailSentSuccess || _vm.emailSentFailure,
                                variant: _vm.emailSentFailure
                                  ? "danger"
                                  : "success"
                              }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.apiResponseMessage(
                                      _vm.emailSentSuccess ||
                                        _vm.emailSentFailure,
                                      _vm.emailSentFailure
                                    )
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                Navigating to view user "
                                ),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.createUserSuccess.fullName))
                                ]),
                                _vm._v(
                                  " in " +
                                    _vm._s(_vm.countDown) +
                                    " seconds...\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66730858", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66730858","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/AddUser.vue
// module id = 1840
// module chunks = 0